export const SIZE = {
  S: 's',
  M: 'm',
  L: 'l',
}
